
/// <reference path='../_all.ts' />

module product_references {
  'use strict';

  export class ProductReference {
    constructor(
      public MeasuringTask: string,
      public ProductReferenceDate: Date,
      public ProductReferenceCustomer: string,
      public ProductReferenceUnits: number,
      public CountryName: string,
      public Industry: string,
      public ProductName?: string
      )
    {
    }
  }

}


